export default __webpack_public_path__ + "static/media/avatar-review-7.0a977ba7.svg";